import store from '@/store/index';
import router from '../router';

export default {
  redirectAfterLogin(response, revalidateUser, previousRoute, modal, fromRegister) {
    const accessConfig = store.state.template.accessConfig;
    // console.log('redirectAfterLogin: ', accessConfig, store);
    //console.log('fromRegister: ', fromRegister);
    if ((fromRegister)&&(accessConfig.alwaysAfterRegister)){
      router
      .push({
        name: accessConfig.firstPageAfterRegister,
        params: accessConfig.firstPageAfterRegisterAlt ?? null,
      })
      .catch(err => {
        console.error('navigation error', err);
        modal.show('dialog', {
          title: '',
          text: accessConfig.loginView.failMessage ? accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
          buttons: [
            {
              title: 'Ok',
              handler: () => {
                modal.hide('dialog');
              },
            },
          ],
        });
      });
    }else if ((response.data.firstLogin && (accessConfig.userProfileOnFirstLogin || accessConfig.altFirstLogin)) || accessConfig.userProfileAlways) {
      if (accessConfig.altFirstLogin){
        router
          .push({
            name: accessConfig.firstPageAlt,
            params: accessConfig.firstPageParamsAlt ?? null,
  
          })
          .catch(err => {
            console.error('navigation error', err);
            modal.show('dialog', {
              title: '',
              text: accessConfig.loginView.failMessage ? accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
              buttons: [
                {
                  title: 'Ok',
                  handler: () => {
                    modal.hide('dialog');
                  },
                },
              ],
            });
          });
      }else if (accessConfig.userProfileRegister) {
        router
          .push({
            name: 'UserProfileRegister',
            params: {
              firstLogin: response.data.firstLogin,
              email: response.data.email,
            },
          })
          .catch(err => {
            console.error('navigation error', err);
            modal.show('dialog', {
              title: '',
              text: accessConfig.loginView.failMessage ? accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
              buttons: [
                {
                  title: 'Ok',
                  handler: () => {
                    modal.hide('dialog');
                  },
                },
              ],
            });
          });
      } else {
        router
          .push({
            name: 'UserProfile',
            params: {
              firstLogin: response.data.firstLogin,
              email: response.data.email,
            },
          })
          .catch(err => {
            console.error('navigation error', err);
            modal.show('dialog', {
              title: '',
              text: accessConfig.loginView.failMessage ? accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
              buttons: [
                {
                  title: 'Ok',
                  handler: () => {
                    modal.hide('dialog');
                  },
                },
              ],
            });
          });
      }
    } else {
      if (revalidateUser) {
        accessConfig.firstPage = previousRoute.name;
        accessConfig.firstPageParams = previousRoute.params;
      }
      router
        .push({
          name: accessConfig.firstPage,
          params: accessConfig.firstPageParams ?? null,
        })
        .catch(err => {
          // console.error('navigation error', err);
          modal.show('dialog', {
            title: '',
            text: accessConfig.loginView.failMessage ? accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
            buttons: [
              {
                title: 'Ok',
                handler: () => {
                  modal.hide('dialog');
                },
              },
            ],
          });
        });
    }
  }

}